// src/Pages/Welcome.tsx
import React from "react";
import { Link } from "react-router-dom";

const Welcome: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#140524] text-white flex items-center justify-center px-4">
      <div className="text-center max-w-3xl">
        <h1
          className="mb-6 text-[52px] leading-tight"
          style={{ fontFamily: "Times New Roman, serif" }}
        >
          Welcome to{" "}
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#e28fff] via-[#d46bff] to-[#4da3ff]">
            WHIPT Organizer
          </span>
        </h1>

        <p
          className="text-xl text-[#d3c9ff] mb-10"
          style={{ fontFamily: "Times New Roman, serif" }}
        >
          Your intelligent life management system. Organize your tasks, budget, and schedule with ease.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/organizer/landing">
            <button
              className="px-10 py-3 text-lg font-semibold bg-[#a339ff] hover:bg-[#b748ff] text-white"
              style={{ borderRadius: 0, fontFamily: "Times New Roman, serif" }}
            >
              Get Started
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Welcome;